import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function NotFoundPage() {
  return (
    <>
      <SEOHead
        title="404 - Siden blev ikke fundet | MC Transport"
        description="Siden du leder efter findes desværre ikke. Kontakt vores vagtcentral døgnet rundt på 70 700 800 eller gå til forsiden."
      />

      <section className="min-h-[70vh] flex items-center justify-center bg-zinc-950 text-white px-4 py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(220,38,38,0.2),transparent_70%)]" />

        <div className="max-w-xl mx-auto text-center relative z-10">
          <div className="inline-block px-4 py-1.5 rounded-full bg-red-600/20 text-red-400 font-mono text-xs font-bold uppercase tracking-wider mb-6 border border-red-500/30">
            Fejlkode 404 · Siden er ikke fundet
          </div>

          <h1 className="font-condensed text-7xl sm:text-9xl font-extrabold uppercase tracking-tight text-white mb-4">
            404
          </h1>

          <h2 className="font-condensed text-2xl sm:text-3xl font-bold uppercase text-zinc-200 mb-4">
            Beklager, siden er kørt af sporet
          </h2>

          <p className="text-zinc-400 text-sm sm:text-base leading-relaxed mb-8">
            Den side, du leder efter, er enten flyttet, slettet eller findes ikke længere. Har du akut brug for autotransport eller autohjælp, står vores vagtcentral klar.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:+4570700800"
              className="w-full sm:w-auto px-6 py-3.5 bg-red-600 hover:bg-red-700 text-white font-condensed text-lg font-bold uppercase tracking-wider rounded shadow transition-colors"
            >
              <i className="fa-solid fa-phone mr-2" aria-hidden="true" />
              <span>Ring til vagtcentralen: +45 70 700 800</span>
            </a>

            <Link
              to="/"
              className="w-full sm:w-auto px-6 py-3.5 bg-zinc-900 hover:bg-zinc-800 text-white font-condensed text-lg font-bold uppercase tracking-wider rounded border border-zinc-700 transition-colors"
            >
              Gå til forsiden
            </Link>

            <Link
              to="/ydelser"
              className="w-full sm:w-auto px-6 py-3.5 bg-zinc-900 hover:bg-zinc-800 text-white font-condensed text-lg font-bold uppercase tracking-wider rounded border border-zinc-700 transition-colors"
            >
              Se ydelser
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
